import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';
import { DebtDynamic, DebtDynamicsChartFilters } from './types/types';

export const debtDynamicsApi = createApi({
  reducerPath: 'debtDynamicsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/debtDynamics`,
  }),
  tagTypes: ['DebtDynamics'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getDebtDynamics: builder.query<DebtDynamic[], DebtDynamicsChartFilters>({
      query: params => ({
        url: ``,
        params,
      }),
      providesTags: ['DebtDynamics'],
    }),
  }),
});

export const { useGetDebtDynamicsQuery } = debtDynamicsApi;
